import { createFileRoute, Outlet } from "@tanstack/react-router";
import { RouteGuard } from "@/components/auth/RouteGuard";

export const Route = createFileRoute("/_authenticated/purchase-orders")({
  component: () => (
    <RouteGuard module="purchase_orders"><Outlet /></RouteGuard>
  ),
});
